import React from 'react'
import PropTypes from 'prop-types'
import { Link as RouterLink } from 'react-router-dom'


const Href = (props) => {
  const { children, className, href, to, toTab, mailto, onClick, ...rest } = props

  if (href) {
    return (
      <a className={className} href={href} rel="noopener noreferrer nofollow" onClick={onClick} {...rest}>
        {children}
      </a>
    )
  }

  if (to) {
    return (
      <RouterLink className={className} to={to} onClick={onClick} {...rest}>
        {children}
      </RouterLink>
    )
  }

  if (toTab) {
    return (
      <a className={className} href={toTab} target="_blank" rel="noopener noreferrer nofollow" onClick={onClick} {...rest}>
        {children}
      </a>
    )
  }

  if (mailto) {
    return (
      <a className={className} href={`mailto:${mailto}`} onClick={onClick} {...rest}>
        {children || mailto}
      </a>
    )
  }

  return (
    <a className={className} onClick={onClick} {...rest}>
      {children}
    </a>
  )
}

Href.propTypes = {
  children: PropTypes.any,
  href: PropTypes.string, // reload page with new link
  to: PropTypes.string, // change route
  toTab: PropTypes.string, // open link in new tab
  mailto: PropTypes.string,
}

Href.contextTypes = {
  store: PropTypes.object,
}


export default Href
